import { render, staticRenderFns } from "./InWaitingListModal.vue?vue&type=template&id=48f18a00&scoped=true&"
import script from "./InWaitingListModal.vue?vue&type=script&lang=js&"
export * from "./InWaitingListModal.vue?vue&type=script&lang=js&"
import style0 from "./InWaitingListModal.vue?vue&type=style&index=0&id=48f18a00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f18a00",
  null
  
)

export default component.exports